import { render, staticRenderFns } from "./ApplicationsDetailsDev.vue?vue&type=template&id=9bcc0c0a"
import script from "./ApplicationsDetailsDev.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetailsDev.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetailsDev.vue?vue&type=style&index=0&id=9bcc0c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports